import { render, staticRenderFns } from "./TherapistDashModalManualBooking.vue?vue&type=template&id=35241f8f&scoped=true"
import script from "./TherapistDashModalManualBooking.vue?vue&type=script&lang=js"
export * from "./TherapistDashModalManualBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35241f8f",
  null
  
)

export default component.exports